<template>
  <div
    class="card-body p-0"
    style="
      display: flex;
      flex-direction: column;
      gap: 10px;
    "
  >
    <button
      type="button"
      class="btn btn-info btn-rounded"
      @click="assignAndOpen()"
      :disabled="httpPending"
    >
      <i v-if="httpPending" class="fa fa-spinner fa-spin"></i>
      <span v-else>Open & Assign Conversation</span>
    </button>
    <button
      type="button"
      class="btn btn-info btn-rounded"
      @click="openReadOnly()"
    >
      <span>Open Conversation In Read Only</span>
    </button>
  </div>
</template>

<script>
import { EventBus } from "../../events/eventBus";
import { mapState, mapGetters } from "vuex";
import SocketHolder from "../../SocketHolder";


export default {
  name: "AssignConversation",
  props: {
    conversationId: String,
    userId: String
  },
  data() {
    return {
      httpPending: false,
    };
  },
  computed: {
    ...mapGetters("agency", ["currentAgencyId"]),
    ...mapState({
      path: (state) => state.connection.path,
      currentUser: (state) => state.user.user,
      currentToken: (state) => state.user.token
    }),
  },
  methods: {
    async assignAndOpen() {
      this.httpPending = true;

      try {
        await this.$ConveyApi.conversationsApi.assignAgentToConversation({
          conversationId: this.conversationId,
          userId: this.currentUser.user_id,
        });

        SocketHolder.socket.emit("assignConversationAgent", this.conversationId, this.currentAgencyId);
        this.$toastr("success", "Conversation Assigned");

        this.httpPending = false;
        EventBus.$emit("conversationReadEvent", this.conversationId);
        EventBus.$emit("close-modal");
        return true;
      } catch (error) {
        this.httpPending = false;
        if (error.response.status === 409) {
          this.$toastr("warning", "Conversation is already assigned to an agent. Viewing conversation in read-only mode.", "Can't Assign Conversation");
          this.$router.push({ path: `/conversations/${this.conversationId}` }).catch(() => { });
          EventBus.$emit("close-modal");
          return;
        } else
          this.$toastr("error", "Error Assigning Conversation");

        return false;
      }
    },
    openReadOnly() {
      EventBus.$emit("close-modal");
      this.$router.push({ path: `/conversations/${this.conversationId}` }).catch(() => { });
    },
  },
};
</script>


<style scoped>
.stretch-footer {
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: -16px;
}
</style>